// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"156":"0d1de0de","604":"cdf9f94e","815":"8e00c913","853":"755bfeb7","860":"910382bc","952":"cdf9f94e"}[chunkId] + ".css";
};